import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function BabyNamesSection ({babynamesData, eleRef}){
    // var eleRef = babynamesData.eleRef;
    // var babynamesData = babynamesData.babynamesData;
    return(
        <section className="babynames-section">
            <div className="section-title">BABY NAMES</div>
            <ul className="names-list">
                {babynamesData.babyNames.map((babyname, i4) => 
                <li  key={i4} id="{babyname.recordid}">
                    <div className="name-info" onClick={(e) => actions.tonamedetails(e,babyname.recordid, babyname.babyname)}>
                        <a href={service.getRedirectUrl(`/baby-names/meaning-of-${babyname.babyname.replace(/-/g, "").replace(/ /g, "-").toLowerCase()}/`)} title={babyname.babyname}>
                            
                            {babyname.gender == "Girl" ?
                            <div className="left gender-icon girl_icon" data-icon-font="&#xe01f;"></div> 
                            : babyname.gender == "Boy" ?
                            <div className="left gender-icon boy_icon" data-icon-font="&#xe022;"></div>
                            :
                            <div className="left gender-icon unisex_icon" data-icon-font="&#xe029;"></div>
                            }
                            <div className="names left">
                                <div className="baby-name M18_21">{babyname.babyname}</div>
                                <span className="nm-ming R14_9e">{babyname.meaning}</span>
                            </div>
                        </a>
                    </div>
                    <div className="right">
                        <span className={babyname.isShortlist ? "heart-icon isChecked right" : "heart-icon right"} data-icon-font={babyname.isShortlist ? "}" : "+"} onClick={() => actions.gotoBabyname(babyname.babyname, babyname.isShortlist ? 0 : 1)} ></span>
                    </div>
                </li>
                )}
            </ul>
            {babynamesData.search_cnt > babynamesData.babyNames.length &&
            <div className="moreResults dev_v_all" title="BABY NAMES" onClick={()=>eleRef.getMoreSearchData(babynamesData.type)}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
